import { SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-common';
import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins } from '@oneaudi/unified-web-common';
export const StyledCard = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  box-shadow: ${(props) => props.theme.global.boxShadow.elevation.level1};
  ${(props) => props.image
    ? css `
          line-height: 0;
        `
    : css `
          padding: ${SYS_SPACE_FIXED_200};
        `};
`;
//# sourceMappingURL=index.styles.js.map